import { Variants } from 'motion';

export const StepContentsVariants: Variants = {
  initial: (direction: number) => ({
    opacity: 0,
    x: direction * 50,
  }),
  animate: {
    opacity: 1,
    x: 0,
    transition: { bounce: 0.2, duration: 0.3 },
  },
  exit: (direction: number) => ({
    opacity: 0,
    x: -direction * 50,
    transition: { duration: 0.1 },
  }),
};
